/* eslint-disable @typescript-eslint/naming-convention */
import axiosInstanceApiGateway from 'config/apiServiceApiGateway'

export type GetHomeTabListParamsType = {
  /** 1-based on the API — `0` and `1` both resolve to the first page. */
  pageIndex: number
  pageSize: number
  /** Case-insensitive "contains" filter on the tab name. */
  name?: string
  /** 1=Draft, 2=Active, 3=Scheduled, 4=Ended, 5=Inactive */
  status?: number
  /** 1=Category, 2=Seasonal, 3=Campaign, 4=Demand Expansion */
  homepageTabbingTypeId?: number
}

export type HomeTabListItemResponseType = {
  id: number
  name: string
  slot?: number
  position?: number
  status: number
  status_name: string
  homepage_tabbing_type_id: number
  homepage_tabbing_type_name: string
  targeting_type_id: number
  targeting_type_name: string
  start_date_time?: string
  end_date_time?: string
  created_by: string
  updated_by: string
  updated_at: string
}

export type HomeTabListPaginationResponseType = {
  page_index: number
  page_size: number
  number_of_elements: number
  total_elements: number
  total_pages: number
  sort: string
  direction: string
}

export type GetHomeTabListResponseType = {
  data: HomeTabListItemResponseType[]
  pagination: HomeTabListPaginationResponseType
  show_multicategory_warning?: boolean
}

export const getHomeTabList = ({
  pageIndex,
  pageSize,
  name,
  status,
  homepageTabbingTypeId,
}: GetHomeTabListParamsType) =>
  axiosInstanceApiGateway.Get<GetHomeTabListResponseType, true>({
    url: '/browse/internal/v1/homepage-tabbings',
    params: {
      'pagination.page_index': pageIndex,
      'pagination.page_size': pageSize,
      ...(name ? { name } : {}),
      ...(status ? { status } : {}),
      ...(homepageTabbingTypeId ? { homepage_tabbing_type_id: homepageTabbingTypeId } : {}),
    },
  })

export type DeleteHomeTabResponseType = {
  status: string
}

/** Soft delete. Rejected by the API for default tabs and Active/Scheduled ones. */
export const deleteHomeTab = (id: string) =>
  axiosInstanceApiGateway.Delete<DeleteHomeTabResponseType, true>({
    url: `/browse/internal/v1/homepage-tabbings/${id}`,
  })

export type HomeTabSortPositionItemType = {
  id: number
  /** 1-based; the API requires a contiguous 1..N permutation for the slot. */
  position: number
}

export type UpdateHomeTabSortPositionPayloadType = {
  slot: number
  /** Must list every non-deleted tab in the slot. */
  items: HomeTabSortPositionItemType[]
}

export type UpdateHomeTabSortPositionResponseType = {
  data: UpdateHomeTabSortPositionPayloadType
}

export const updateHomeTabSortPosition = (payload: UpdateHomeTabSortPositionPayloadType) =>
  axiosInstanceApiGateway.Put<UpdateHomeTabSortPositionResponseType, true>({
    url: '/browse/internal/v1/homepage-tabbings/sort-position',
    data: payload,
  })
